<template>
    <div class="full-width" ref="companyInputsDom" v-loading="loading">
        <el-scrollbar>

        <div style="margin-top: 15px; margin-bottom: 15px; text-align: left;display: flex;align-items: center;justify-content: space-between;">
            <div>
                <el-text type="primary" @click="clickReturnBtn">
                    <font-awesome-icon icon="fa-solid fa-chevron-left" />
                    <span style="margin-left: 5px" tkey="返回">{{i18n.tkey("lang_return")}}</span>
                </el-text>
            </div>



        </div>

        <el-descriptions title=" " :column="width < 768 ? 1 : 2" :size="'large'">
            <el-descriptions-item :label="`${i18n.tkey('lang_company_name')}*`">
                <el-input
                        v-model="companyInfoObj.companyname"
                        :placeholder="i18n.tkey('lang_company_name')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="50"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="`${i18n.tkey('lang_company_name_eng')}`">
                <el-input
                    v-model="companyInfoObj.companyname2"

                    style="width: 75%"
                    show-word-limit
                    maxlength="50"
                    :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="`${i18n.tkey('lang_company_address')}*`">
                <el-input
                        v-model="companyInfoObj.address"
                        :placeholder="i18n.tkey('lang_company_address')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="100"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="`${i18n.tkey('lang_company_address_eng')}`">
                <el-input
                    v-model="companyInfoObj.address2"

                    style="width: 75%"
                    show-word-limit
                    maxlength="100"
                    :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_area_code')">
                <areaNumberSelect
                    v-model="companyInfoObj.sharewhcom"
                    @change="autoSaveInfo"
                    style="width: 75%; display: inline-block;"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="`${i18n.tkey('lang_company_telphone')}*`">
                <el-input
                        v-model="companyInfoObj.telephone"
                        :placeholder="i18n.tkey('lang_company_telphone')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="35"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="`${i18n.tkey('lang_company_email')}*`">
                <el-input
                        v-model="companyInfoObj.email"
                        :placeholder="i18n.tkey('lang_company_email')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="50"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_company_fax')">
                <el-input
                        v-model="companyInfoObj.fax"
                        :placeholder="i18n.tkey('lang_company_fax')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="35"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_company_website')">
                <el-input
                        v-model="companyInfoObj.website"
                        :placeholder="i18n.tkey('lang_company_website')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="30"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_company_telphone_2')">
                <el-input
                        v-model="companyInfoObj.mobilephone"
                        :placeholder="i18n.tkey('lang_company_telphone_2')"
                        style="width: 75%"
                        show-word-limit
                        maxlength="35"
                        :disabled="eshopopeeTag"
                />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_company_auth')">
                <span>{{companyStatus}}</span>
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_authenticate_expiration')">
                <span>{{companyInfoObj.expiration}}</span>
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_shop_exp')">
                <shopExpirationSpan />
            </el-descriptions-item>

            <el-descriptions-item :label="i18n.tkey('lang_company_logo')">
                <div style="display: inline-block">
                    <uploadImg
                        v-model="companyInfoObj.logo"
                        :useBtn="false"
                        :sizeLimit="1024"
                        @selectComplete="autoSaveInfo"
                    />
                </div>
            </el-descriptions-item>
        </el-descriptions>

        <div style="margin-top: 20px" v-show="false">
            <el-button type="primary" style="width: 100px" @click="submitCheck" tkey="保存">{{i18n.tkey("lang_save")}}</el-button>
        </div>

        <div style="margin-top: 10px" v-show="false">
            <el-button type="danger" style="width: 100px" tkey="企業註銷">{{i18n.tkey("lang_logoff_company")}}</el-button>
        </div>

        <!--  編輯名片樣式的組件  -->
        <div v-if="null != currEditCardId" class="unvisible-savecard-iframe">
            <cardEditorIframe :id="currEditCardId" :tag="'saveCard'" @save-success="saveCardCallback" />
        </div>
          <div>
            <a
                class="a-text"
                :href="eshopopeeUrl"
                v-show="eshopopeeTag"
                target="eshopopee"
            >
              <el-button
                  style="margin: 8px"
                  type="primary"
                  plain
                  :color="'#32c5d2'"
                  class="icon-button"
              >
                <font-awesome-icon icon="fa-solid fa-pen-to-square" />
                &nbsp;
                <span tkey="編輯信息">{{i18n.tkey("lang_edit_information")}}</span>
              </el-button>
            </a>

            &nbsp;
          </div>
<!--          lang_wrok_show_commpany_tpye-->
          <div style="text-align: left">

            <hr>
            <record7CompanyEditor />
          </div>

        </el-scrollbar>
    </div>

</template>

<script setup>
import {onMounted, ref, toRef, computed, getCurrentInstance, inject, provide} from 'vue'
    import { useUserinfo } from '@/stores/userinfo'
    import { useCompanyinfo } from '@/stores/companyinfo'
    import areaNumberSelect from '@/components/shopopee/form/areaNumberSelect'
    import shopExpirationSpan from "@/components/shopopee/shop/shopExpirationSpan"
    import cardEditorIframe from "@/components/shopopee/card/cardEditorIframe"
    import uploadImg from "@/components/shopopee/form/uploadImg"
    import companyApi from "@/request/companyApi";
    import myUtil from "@/util/util";
    import cardApi from "@/request/api";
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faChevronLeft,faPenToSquare } from '@fortawesome/free-solid-svg-icons'
    import record7CompanyEditor from "@/components/shopopee/record7/record7CompanyEditor"

    library.add(faChevronLeft,faPenToSquare)

    const { proxy } = getCurrentInstance()

    const props = defineProps(["showReturnBtn"])

    const i18n = inject("i18n")

    const width = ref(425)

    const userInfoRef = toRef(useUserinfo())
    const companyInfoRef = toRef(useCompanyinfo())

    const { goShopControlView } = inject('phoneView', { goShopControlView: () => { proxy.$router.push({name: "shopController"} )} })

    const loading = ref(false)
    const companyInfoObj = toRef({})

    const currEditCardId = ref(null)

    const eshopopeeUrl = computed(() => {
        let url = "javascript: void(0)"

        if (null !== userInfoRef.value.acccompanycode){
            url = myUtil.generateEshopopeeManagerJumpUrl(userInfoRef.value.acccompanycode, userInfoRef.value.login, userInfoRef.value.password, "MemberCom.asp?shopForm=shopopee")
        }

        return url
    })

    const eshopopeeTag = computed(() => {
        return null !== userInfoRef.value.acccompanycode
    })

    const companyStatus = computed(() => {
        let authText = ""

        switch (companyInfoRef.value.webmem) {
            // case -1: authText = "已認證"; break;
            // case 0: authText = "未認證"; break;
            // case 1: authText = "認證中"; break;
            // case 2: authText = "已過期"; break;
            // case 3: authText = "未激活"; break;
            // case 4: authText = "未填寫"; break;

            case -1: authText = i18n.tkey("lang_certified"); break;
            case 0: authText = i18n.tkey("lang_not_certified"); break;
            case 1: authText = i18n.tkey("lang_under_certification"); break;
            case 2: authText = i18n.tkey("lang_expired"); break;
            case 3: authText = i18n.tkey("lang_not_active"); break;
            case 4: authText = i18n.tkey("lang_not_fill"); break;
        }

        return authText
    })

    function getCompanyInfo(){
        loading.value = true
        const request = companyApi.getCompanyInfo
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode

        request.send(params, getCompanyInfoCallback)
    }

    function getCompanyInfoCallback(res){
        loading.value = false
        if (res.code == 200){
            const obj = res.detail

            myUtil.mergeObj(obj, companyInfoRef.value)
            myUtil.mergeObj(obj, companyInfoObj.value)
        }else{
            myUtil.alertError(res.msg)
        }
    }

    function submitCheck(){
        if (myUtil.isEmpty(companyInfoObj.value.companyname)){
            myUtil.alertWarning(i18n.tkey("lang_input_companyname_pls"))
            return
        }

        if (myUtil.isEmpty(companyInfoObj.value.address)){
            myUtil.alertWarning(i18n.tkey("lang_input_companyaddress_pls"))
            return
        }

        if (myUtil.isEmpty(companyInfoObj.value.telephone)){
            myUtil.alertWarning(i18n.tkey("lang_input_companytel_pls"))
            return
        }

        if (myUtil.isEmpty(companyInfoObj.value.email)){
            myUtil.alertWarning(i18n.tkey("lang_input_companyemail_pls"))
            return
        }

        updateCompanyInfo()
    }

    function updateCompanyInfo(){
        loading.value = true

        const request = companyApi.updateCompany
        const params = request.getParams()

        params.address = companyInfoObj.value.address
        params.companycode = companyInfoObj.value.companycode
        params.companyname = companyInfoObj.value.companyname
        params.email = companyInfoObj.value.email
        params.fax = companyInfoObj.value.fax
        params.id = companyInfoObj.value.id
        params.mobilephone = companyInfoObj.value.mobilephone
        params.poscash = companyInfoObj.value.poscash
        params.sharewhcom = companyInfoObj.value.sharewhcom
        params.telephone = companyInfoObj.value.telephone
        params.website = companyInfoObj.value.website
        params.logo = companyInfoObj.value.logo

        request.send(params, updateCompanyCallback)
    }

    function updateCompanyCardList() {
        const request = cardApi.queryCompanyDefaultMemberWork
        const params = request.getParams()

        params.companycode = companyInfoRef.value.companycode

        request.send(params, (res) => {
            if (res.code == 200){
                currEditCardId.value = res.detail.id
            }else{
                loading.value = false
            }
        })
    }

    function updateCompanyCallback(res){
        if (res.code == 200){
            updateCompanyCardList()
        }
    }

    function saveCardCallback(){
        myUtil.alertSuccess(i18n.tkey("lang_save_success"))
        loading.value = false
        currEditCardId.value = null

        getCompanyInfo()
    }

    function clickReturnBtn(){
      console.log(proxy.$route.query)
      if(proxy.$route.query.mfrom === "home"){

        proxy.$router.push({name: "home"})
      }else{
        goShopControlView()
      }
    }

    function autoSaveInfo(){
        setTimeout(() => {
            submitCheck()
        }, 100)
    }

    onMounted(() => {
        width.value = proxy.$refs.companyInputsDom.offsetWidth

        getCompanyInfo()
    })
</script>

<style scoped>
    .unvisible-savecard-iframe {
        position: absolute;
        left: 0;
        top: 200vh;
        width: 900px;
        height: 900px;
        z-index: 9999;
    }

    .full-width {
        width: 100%;
        height: 100%;
        padding-left: 5px;
        padding-right: 5px;
        box-sizing: border-box;
        padding-bottom: 15px;
    }
</style>